import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingComponent } from './landing/landing.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalAuthModule } from './modal-two-authentication/modal-auth-component.module';
import { ForgotPasswordComponent } from './modal-forgot-password/forgot-password/forgot-password.component';
import { CodeInputModule } from 'angular-code-input';
import { InputPasswordComponent } from './input-password/input-password.component';
import { LoadingModule } from './loading/loading.module';
// import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalNotPasskeyComponent } from './modal-not-passkey/modal-not-passkey.component';
import { MatIconModule } from '@angular/material/icon';
import { AddressModalModule } from './address-modal/address-modal.module';

@NgModule({
  declarations: [
    LandingComponent,
    ForgotPasswordComponent,
    InputPasswordComponent,
    ModalNotPasskeyComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ModalAuthModule,
    LoadingModule,
    MatIconModule,
    FormsModule,
    CodeInputModule,
    BrowserAnimationsModule, // required animations module
    AddressModalModule,
    // ToastrModule,
  ],
  exports: [
    LandingComponent,
    ForgotPasswordComponent,
    InputPasswordComponent,
    ModalNotPasskeyComponent,
  ],
})
export class ComponentsModule {}
